<div [formGroup]="taxWithholdingsFormGroup" id="create-request-tax-withholdings">

    <span class="subtitle" data-testid="header">Tax withholding</span>

    <mm-banners *ngIf="hasInternationalFedTaxError" [bannerText]="[internationalFedTaxErrorText]" [type]="'error'" data-testid="internationalFedTaxError"></mm-banners>
    <mm-banners *ngIf="showWarning" [bannerText]="[warningText]" [type]="'warning'" data-testid="taxExemptWarning"></mm-banners>

    <mm-banners *ngIf="(showMississippiEarlyDistributionWarning || showMassachusettsDistributionWarning)" [bannerText]="[stateTaxAttentionRequiredWarningMessage]" [type]="'warning'" data-testid="distributionWarningMsg"></mm-banners>

    <mm-banners *ngIf="show100TweCheckWarning" [bannerText]="[oneTimeCheck100PercentTWEInfo]" [type]="'information'">
    </mm-banners>

    <!-- 7-QCD BANNER -->
    <mm-banners *ngIf="(isQcdDistributionReason && !hasInternationalFedTaxError) || (isQcdY4DistributionReason)" [bannerText]="[qcdDistributionInformation]" [type]="'information'" [showCloseIcon]="false" data-testid="qcdDistributionInformation"></mm-banners>

    <!-- RMD BANNER -->
    <mm-banners *ngIf="showRmdBanner" [bannerText]="[rmdAlertText]" [type]="'information'"></mm-banners>

    <!-- COMBINED FED AND STATE TAX ERROR -->
    <mm-banners *ngIf="taxWithholdingsFormGroup?.errors && !hasOnlyStateTaxError" [bannerText]="[fedAndStateTaxSumError]" [type]="'error'" data-testid="fed-and-state-tax-error"></mm-banners>

    <!-- NRA BANNER -->
    <mm-banners *ngIf="nraIndicator && !isQcdDistributionReason && !isQcdY4DistributionReason" [bannerText]="[nraText]" [type]="'information'"></mm-banners>

    <!-- TWE BANNER -->
    <mm-banners *ngIf="isAchTweAuthorizationError" [bannerText]="[achTWEAuthorizationErrorText]"
        [hyperlink]="achTWErrorLink" [achRedirect]="true" [type]="'error'"
        data-testid="transactionDetailsAch_achTweWarning">
    </mm-banners>

    <div *ngIf="!isAchTransaction || ((isCreateRecurringAchFromOnRequest$ | async) || isAchTransaction && isOneTime)" id="tax-withholding-text" data-testid="tax-withholding-text">
        <span>{{taxWithholdingText}}</span>
    </div>

    <div class="row">
        <!-- FED TAX -->
        <div class="tax-container">
            <div *ngIf="!nraIndicator" class="tax-percent" id="federal-percent">
                <!-- FEDERAL TAX LABEL -->
                <div id="federal-tax-label" data-testid="fed-tax-title" [class.error-text]="isFedTaxInvalid">Federal tax</div>


                <!-- FEDERAL TAX INPUT BOX -->
                <input *ngIf="isPositionsTransaction; else elseBlock" type="text" formControlName="fedTaxPercent" (blur)="onFedTaxBlur()"
                    [class.is-invalid]="fedTaxPercent.invalid" (paste)="onPaste($event)"
                    (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                    data-testid="fed-tax-input" maxlength="10">

                <ng-template #elseBlock>
                    <div class="sdps-form-element__control sdps-form-element__control--addon input-container">
                        <button type="button" class="sdps-button sdps-button--secondary sdps-button--input-right sdps-button--small calc-button" data-testid="fedCalculator"
                            [class.is-invalid]="fedTaxPercent.invalid" (click)="onFedTaxCalculatorClick()" [attr.disabled]="fedTaxPercent.disabled || !amount?.value || amount?.invalid || null">
                            <i class="sch-calculator calc-icon"></i>
                        </button>
                        <input type="text" formControlName="fedTaxPercent" (blur)="onFedTaxBlur()"
                            [class.is-invalid]="fedTaxPercent.invalid" class="sdps-input sdps-input--small sdps-input--addon-right tax-field-input"
                            (paste)="onPaste($event)" (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                            data-testid="fed-tax-input" maxlength="10">
                    </div>
                </ng-template>

                <!-- FEDERAL TAX ERROR -->
                <div *ngIf="fedTaxPercent.invalid && !hasInternationalFedTaxError" class="alert-text" data-testid="fed-tax-error">
                    {{fedTaxError}}
                </div>
            </div>
        </div>

        <!-- STATE TAX -->
        <div id="state-tax-container">
            <div class="tax-container">
                <div class="tax-percent" id="state-percent">
                    <!-- STATE TAX LABEL -->
                <div id="state-tax-label" data-testid='state-tax-title' [class.error-text]="isStateTaxInvalid">{{stateTaxLabel}}
                    </div>

                    <!-- STATE TAX INPUT -->
                    <input *ngIf="isPositionsTransaction || nraIndicator; else elseBlockStateTax" type="text" formControlName="stateTaxPercent" (blur)="onStateTaxBlur()"
                        [class.is-invalid]="stateTaxPercent.invalid" (paste)="onPaste($event)"
                        (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                        data-testid="state-tax-input" maxlength="10">

                    <ng-template #elseBlockStateTax>
                        <div class="sdps-form-element__control sdps-form-element__control--addon input-container">
                            <button type="button" class="sdps-button sdps-button--secondary sdps-button--input-right sdps-button--small calc-button" data-testid="stateCalculator"
                                (click)="onStateTaxCalculatorClick()" [attr.disabled]="stateTaxPercent.disabled || !amount?.value || amount?.invalid || null">
                                <i class="sch-calculator calc-icon"></i>
                            </button>
                            <input type="text" formControlName="stateTaxPercent" (blur)="onStateTaxBlur()"
                                [class.is-invalid]="stateTaxPercent.invalid" class="sdps-input sdps-input--small sdps-input--addon-right tax-field-input"
                                (paste)="onPaste($event)" (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                                data-testid="state-tax-input" maxlength="10">
                        </div>
                    </ng-template>

                    <!-- STATE TAX ERROR -->
                    <div *ngIf="stateTaxPercent.invalid || hasMississippiStateTaxErrorText" class="alert-text" data-testid="state-tax-error">
                        {{stateTaxError}}
                    </div>

                </div>
            </div>
            <!-- VIEW STATE TAX LINK -->
            <span id="view-state-tax-info-link">
                <a href="https://www.schwab.com/resource/state-income-tax-withholding-information-for-individual-retirement-accounts"
                    target="_blank">View
                    state tax information</a>
            </span>
        </div>

        <!-- DISTRIBUTION REASON -->
        <div id="distribution-reason-container">
            <div class="input-container">
                <div id="ach-distribution-reason" *ngIf="isAchTransaction && !(isCreateRecurringAchFromOnRequest$ | async); else elseBlockDistributionReason"
                    class="ach-distribution-container">
                    <label for="distributionReason">Distribution reason</label>
                    <input type="text" formControlName="distributionReason">
                </div>
                <ng-template #elseBlockDistributionReason>
                    <mm-select-dropdown-control *ngIf="distributionReasonModel$" id="distribution-reason-select" [parentForm]="taxWithholdingsFormGroup"
                        label="distributionReasonModel.title" [selectModel]="distributionReasonModel$"
                        [tooltipVerbiage]="distributionReasonTooltip" [tooltipHtml]="distributionReasonTooltipHtml" [defaultValue]="distributionReasonControl">
                    </mm-select-dropdown-control>
                </ng-template>
            </div>
            <a id="client-ira-agreement-link" (click)="displayIraAgreementModal()">View client IRA agreement</a>
        </div>
    </div>
    <cashiering-ira-agreement-modal [showModal]="showCashieringIRAAgreementModal"></cashiering-ira-agreement-modal>
    <mm-twe-calculator-modal [showModal$]="showTweCalculatorModal" [isFedTax$]="isFedTax$.asObservable()"
        (onApplyWithholdings)="setTaxPercentValue($event.fedTaxCalculatedPercent, $event.stateTaxCalculatedPercent)">
    </mm-twe-calculator-modal>
</div>
